/**
 * Created by "Juanito Goncalves <juanito.goncalves@scub.net>" on 31/07/16.
 */
export class AdresseInternet {
	personneId: number;
	id: number;
	url: string;
	invalide: boolean;
}